import React, {useContext, useEffect, useState} from 'react';
import {DispatchContext} from '../../../../store';
import {useNavigate} from 'react-router';
import {useLocation} from 'react-router-dom';
import {deaccessionAction} from '../../../../services/DeaccessionServices';
import {SNACKBAR_OPEN} from '../../../../reducers';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {Form, Formik} from 'formik';
import {Button, Card, Grid} from '@mui/material';
import EntryOneEdit from './EntryOneEdit';
import EntryTwoEdit from './EntryTwoEdit';
import EntryThreeEdit from './EntryThreeEdit';
import {Images} from '../../../../common/Assets/Images';
import {deaccessionInitialValue} from './DeaccessionModel';

export default function DeaccessionUpdate() {
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const id = params.get('id');
  const [deaccession, setDeaccession] = useState(deaccessionInitialValue);
  const code = 'en';

  useEffect(() => {
    fetchDeaccessionDetail();
  },[]);

  const fetchDeaccessionDetail = () => {
    deaccessionAction('get', id).then(res => {
      setDeaccession(res?.data);
    })
  }

  const onSubmit = (values) => {
    const deaccessionValue = {
      museum_id: [values?.museum_id],
      accession_no: values?.accession_no,
      catalogue_id: values?.id,
      submission_date: new Date().toISOString().slice(0, 10),
      attachment_ids: values?.attachments?.map((val) => val?.id),
      translations: {
        en: {
          justification: values?.justification || ''
        }
      },
      state: 'resubmitted'
    }
    deaccessionAction('put', id,{...deaccessionValue}).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Deaccession updated successfully'}
      });
      navigate(`/management/artifact-managements/${id}`)
    })
  }

  return (
    <div>
      <Box sx={{display: {sm: 'flex', xs: 'column'}, alignItems: 'center', mt: 7, mb: 2}}>
        <Typography className={'text-500 font30'} sx={{color: '#757575'}}>Deaccession Request</Typography>
      </Box>
      <Box className={'header-divider'}/>
      <Formik initialValues={deaccession}
              onSubmit={onSubmit}
              validateOnBlur={true} enableReinitialize
      >
        {({isSubmitting, touched, errors, values, setFieldValue, ...formik}) => (
          <Form>
            <Box>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <EntryOneEdit code={code}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <EntryTwoEdit code={code}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <EntryThreeEdit code={code}/>
                </Grid>
              </Grid>
              <Box className={'header-divider'} sx={{marginTop: 10, marginBottom: 10}}/>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  {values?.catalogue?.attachments?.length > 0 &&
                  <Card className={'box-shadow'} sx={{p: 4}}>
                    <Grid container spacing={2}>
                      {values?.catalogue?.attachments?.length > 0 && values?.catalogue?.attachments?.map((val, index) => (
                        <Grid key={index} item sm={2.4} xs={12}>
                          <img src={val?.file || Images?.logoWhite} width={'100%'} alt="image"/>
                        </Grid>
                      ))}
                    </Grid>
                  </Card>}
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Grid container spacing={2}>
                <Grid item sm={9} xs={12}/>
                <Grid item sm={3} xs={12}>
                  <Grid container spacing={2}>
                    <Grid item sm={6} xs={12}>
                      <Button onClick={() => navigate(-1)} variant={'outlined'} color={'error'}
                              fullWidth>Cancel</Button>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                      <Button variant={'contained'} type={'submit'} fullWidth>Submit</Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  );
}